import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { renderRoutes } from 'react-router-config'
import {
  Drawer,
  List,
  Divider,
  IconButton,
  Container,
  Grid,
  makeStyles,
  Typography,
  Button,
  Avatar,
} from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ListItems from './ListItems'
import LogoIcon from '../LogoIcon'
import { useAuth } from '../../modules/security/containers/AuthProvider'
import { useTranslation } from 'react-i18next'

const drawerWidth = 210

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },

  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  userDisplay: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: "2px",
    justifyContent: 'flex-start',
    padding: '0px',
  },
  menuButton: {
    marginRight: 36,
  },
  displayHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerRoot: {
    position: 'fixed',
    height: '100vh',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: theme.spacing(10),
  },
  container: {
    padding: '0px',
    paddingRight: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
  },
  centerHorizontal: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  logoAndChevronContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  horizontalSpacer: {
    marginLeft: `${drawerWidth + theme.spacing(2)}px`,
  },
  listContainer: {
    height: '100%',
  },
  blockedScreen: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  userPaper: {
    boxShadow: '4px 3px 1px -2px rgb(0 0 0 / 8%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)',
    padding: '16px',
    margin: '0px 5px 7px 5px',
    borderRadius: '4px',
    backgroundColor: '#066a0b69',
    overflowX: 'hidden'
  },
  userId: {
    padding: "5px",
    marginTop: "5px",
    marginBottom: "10px",
    fontSize: "13px",
    fontWeight: "700",
  },
  userEmail: {
    color: '#1b4e2d',
    fontWeight: '400',
  },
  userRole: {
    fontWeight: '700',
    fontSize: clsx(document.getElementsByTagName('html')[0].getAttribute('dir') === 'ltr' ? "13px" : "17px")
  },
}))

export default function Layout({ route }) {
  const classes = useStyles()
  const [open, setOpen] = useState(true)

  const { t } = useTranslation()
  const { me, logout } = useAuth()

  const handleDrawerOpen = () => {
    setOpen(true)
  }
  const handleDrawerClose = () => {
    setOpen(false)
  }


  return me === null || me?.roles.length > 0 ? (
    <div className={classes.root}>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          root: classes.drawerRoot,
        }}
        open={open}
      >
        <div className={classes.logoAndChevronContainer}>
          <LogoIcon
            className={clsx(!open && classes.displayHidden)}
            height="45px"
          />
          <div
            className={clsx(
              classes.toolbarIcon,
              !open && classes.displayHidden,
            )}
          >
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
        </div>
        <div
          className={clsx(
            classes.toolbarIcon,
            classes.centerHorizontal,
            open && classes.displayHidden,
          )}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
          >
            <MenuIcon />
          </IconButton>
        </div>
        <Divider />
        <List className={classes.listContainer}>
            <div className={clsx(classes.userDisplay, !open && classes.displayHidden)}>
              <div style={{ marginBottom: "8px" }}>
                <Avatar sx={{bgcolor: 'rgb(8, 92, 37)'}} alt={me?.userName} style={{ fill: 'inherit', width: "35px", height: "35px" }} />
              </div>
              <div>
                <Typography className={classes.userId}>
                  {/** mem */}
                  <span className={classes.userRole}>{me?.roles[0] === "administrator" ? t('userPresentation.admin') 
                                                    : me?.roles[0] === "supervisor" ? t('userPresentation.supervisor')
                                                    : me?.roles[0] === "challengeSupervisor" ? t('userPresentation.challengeSupervisor')
                                                    : me?.roles[0] === "seniorIntervenor" ? t('userPresentation.seniorIntervenor')
                                                    : (me?.entityType !== 10 && me?.entityType !== 9) ? t('userPresentation.intervenant')
                                                    : t('userPresentation.intervenantSA')}
                  </span> <br></br>
                  <span className={classes.userEmail}>{me?.username.length > 23 ? me?.username.substring(0,22) + "..." : me?.username}</span>
                </Typography>
              </div>
            </div> 
          <ListItems />
        </List>
      </Drawer>
      <main className={clsx(classes.content, open && classes.horizontalSpacer)}>
        <Container maxWidth="lg" className={classes.container}>
          <Grid item xs={12}>
            <div>{renderRoutes(route.routes)}</div>
          </Grid>
        </Container>
      </main>
    </div>
  ) : (
    <div className={classes.blockedScreen}>
      <Typography variant="body1" component="p">
        {t('layout.accountBlocked')}
      </Typography>
      <Button variant="contained" color="primary" onClick={logout}>
        {t('layout.disconnect')}
      </Button>
    </div>
  )
}
Layout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  route: PropTypes.object.isRequired,
}
